import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfo/HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class HomestayTermsOfService extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={2382} />;
  }
}
export default HomestayTermsOfService;
